var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"member-card",attrs:{"data-type":"countries"}},[_c('div',{staticClass:"member-list"}),_c('div',_vm._l((_vm.countries),function(item,i){return _c('div',{key:i,ref:`scroller-${_vm.year}`,refInFor:true,class:{
        scroller: _vm.countries.length > 1,
        'scroller--single': _vm.countries.length === 1,
      },attrs:{"data-order":`${item.type}-${item.order ? item.order : i}`}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }